import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6",
  "data-kt-menu": "true",
  style: {"width":"100%","max-width":"600px"}
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "row gx-3 gy-2 align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"col-sm-4\"><div class=\"card flex-grow-1\"><a href=\"https://doptor.seip-fd.gov.bd/\" target=\"_blank\" class=\"card-body text-center\"><div class=\"d-flex justify-content-center align-items-center\"><img src=\"media\\logos\\logo-1.svg\" alt=\"DOPTOR Logo\" width=\"50\" height=\"50\"><span class=\"ms-2\" style=\"max-width:100px;overflow:hidden;text-overflow:ellipsis;\">ADMIN PANEL</span></div></a></div></div>", 1)
const _hoisted_6 = { class: "col-sm-4" }
const _hoisted_7 = { class: "card flex-grow-1" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media\\logos\\fmc_logo.png",
    alt: "Finman Cloud Logo",
    width: "50",
    height: "50"
  }),
  /*#__PURE__*/_createElementVNode("span", {
    class: "ms-2",
    style: {"max-width":"100px","overflow":"hidden","text-overflow":"ellipsis"}
  }, "Finman Cloud")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "col-sm-4" }
const _hoisted_12 = { class: "card flex-grow-1" }
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media\\logos\\favicon.ico",
    alt: "Mini ERP Logo",
    width: "50",
    height: "50"
  }),
  /*#__PURE__*/_createElementVNode("span", {
    class: "ms-2",
    style: {"max-width":"100px","overflow":"hidden","text-overflow":"ellipsis"}
  }, "MiniERP")
], -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", {
                href: `https://finman.seip-fd.gov.bd/fm-users/login?params=${this.finmanparam}`,
                target: "_blank",
                class: "card-body text-center"
              }, _hoisted_10, 8, _hoisted_8)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("a", {
                href: `https://erp.seip-fd.gov.bd?params=${this.minierpParam}`,
                target: "_blank",
                class: "card-body text-center"
              }, _hoisted_15, 8, _hoisted_13)
            ])
          ])
        ])
      ])
    ])
  ]))
}